import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState } from "react"
import Logo from '../assets/Logo.png'

function NavBar({ siteTitle }) {

    const [isExpanded, toggleExpansion] = useState(false)

    return (
        <div className='flex flex-wrap md:flex-wrap justify-center bg-ronsof-one font-ronsof-one'>
            <nav className="p-3">
                <div className="flex items-center flex-shrink-0 text-white mr-6">
                    <span className="font-semibold text-xl tracking-tight">{siteTitle}</span>
                </div>
                <div className="block lg:hidden">
                    <button onClick={() => toggleExpansion(!isExpanded)} className="flex items-center px-3 py-2 border rounded text-blue-200 border-blue-400 hover:text-white hover:border-white">
                        <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
                    </button>
                </div>
                <div className={`${isExpanded ? `block` : `hidden`} w-full block flex-grow lg:flex lg:items-center lg:w-auto`}>
                    <Link to='/'>
                        <img className='w-8 mx-20 animation-ronsof-one' src={Logo} alt='Logo' />
                    </Link>
                    <div className="text-sm lg:flex-grow">
                        <Link to={`/`} activeStyle={{ color: '#999999'}} activeClassName='active' href="#responsive-header" className="animation-ronsof-one block mt-4 lg:inline-block lg:mt-0 color-ronsof-two hover:text-white mr-20">
                            Home
                        </Link>
                        <Link to={`/pageempresa`} activeStyle={{ color: '#999999'}} activeClassName='active' className="animation-ronsof-one block mt-4 lg:inline-block lg:mt-0 color-ronsof-two hover:text-white mr-20">
                            Empresa
                        </Link>
                        <Link to={`/pagesoluction`} activeStyle={{ color: '#999999'}} activeClassName='active' className="animation-ronsof-one block mt-4 lg:inline-block lg:mt-0 color-ronsof-two hover:text-white mr-20">
                            Soluções
                        </Link>
                        <Link to={`/pageprojetos`} activeStyle={{ color: '#999999'}} activeClassName='active' className="animation-ronsof-one block mt-4 lg:inline-block lg:mt-0 color-ronsof-two hover:text-white mr-20">
                            Projetos
                        </Link>
                        <Link to={`/pagecontato`} activeStyle={{ color: '#999999'}} activeClassName='active' className="animation-ronsof-one block mt-4 lg:inline-block lg:mt-0 color-ronsof-two hover:text-white mr-20">
                            Contato
                        </Link>
                    </div>
                </div>
            </nav>
        </div>
    )
}

NavBar.propTypes = {
    siteTitle: PropTypes.string,
}

NavBar.defaultProps = {
    siteTitle: ``,
}

export default NavBar